import { ChainId } from '@pancakeswap/chains'

export const getFarmsPriceHelperLpFiles = (chainId: ChainId) => {
  return []
}
